module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-9-a27dfb578cdbd3dd7e22067a3f038b3b.jpg";